import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link"]

  navigate(event) {
    // Verhindere die Navigation, wenn ein Link oder Button geklickt wurde
    if (event.target.closest('a, button, .dropdown-menu')) {
      return
    }
    
    const url = this.element.dataset.url
    if (url) {
      window.location.href = url
    }
  }
} 